import client from './main-client';

export const addOwnerNoteApi = (data) => client().post('/borrower-company-notes', data);
export const updateOwnerNoteApi = (data) => client().patch(`/borrower-company-notes/${data.id}`, data);
export const deleteOwnerContactApi = (data) => client().delete(`/borrower-company-notes/${data.id}`);
export const getAllOwnerNotesApi = (params) => client().get('/borrower-company-notes', { params });
